import PharmacyOrders from '@/assets/images/services-cards/ico033.svg';
import DiagnosticTests from '@/assets/images/services-cards/ico034.svg';
import Vaccinations from '@/assets/images/services-cards/ico035.svg';
import PhysicalTherapy from '@/assets/images/services-cards/ico036.svg';
import NursingCare from '@/assets/images/services-cards/ico037.svg';
import SuggestService from '@/assets/images/services-cards/ico038.svg';

export default [
  {
    image: PharmacyOrders,
    labelId: 'txt019',
    description: 'txt622__desktop',
    disabled: true,
  },
  {
    image: DiagnosticTests,
    labelId: 'txt020',
    disabled: true,
  },
  {
    image: Vaccinations,
    labelId: 'txt023',
    disabled: true
  },
  {
    image: PhysicalTherapy,
    labelId: 'txt021',
    disabled: true
  },
  {
    image: NursingCare,
    labelId: 'txt024',
    disabled: true
  },
  {
    image: SuggestService,
    labelId: 'txt025',
    description: 'txt623__desktop'
  }
]